import React, { useMemo } from "react";

import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import { AmenityIcon } from "@app/components/amenity-icon/amenity-icon";
import { useAppContext } from "@app/helpers/hooks";
import type { TripOption } from "@app/types/results-types";

import * as AmenitiesHelper from "../../helpers/amenities";

interface Props {
  amenities: TripOption["amenities"];
  size: "md" | "sm" | "lg";
}

export const AmenitiesList: React.FC<Props> = React.memo(props => {
  const { translator } = useAppContext();
  const amenity_keys = useMemo(() => {
    const amenities = Array.isArray(props.amenities)
      ? props.amenities
      : AmenitiesHelper.filterSupportedAmenities(props.amenities);
    return AmenitiesHelper.getDisplayableAmenityKeys(amenities);
  }, [props.amenities]);

  return (
    <Stack spacing={1} direction="column">
      {amenity_keys.map(key => (
        <Label
          size="md"
          fontWeight="bold"
          startIcon={<AmenityIcon size={props.size} amenity_key={key} />}
          key={key}
        >
          {AmenitiesHelper.getLabelText(translator, key)}
        </Label>
      ))}
    </Stack>
  );
});
